import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      yes: "Yes",
      no: "No",
      login: "Login",
      loginAsGuest: "Login as guest",
      emailAddress: "Email Address",
      password: "Password",
      gotoRegister: "Don't have an account? Register",
      registerUser: "Register User",
      register: "Register",
      name: "Name",
      backToLogin: "Already have an account? Login",
      serviceType: "Service Type",
      selectPickup: "Pickup Service",
      selectDropoff: "Drop-off Service",
      selectOrders: "My All Orders",
      selectAroundCity: "Around City",
      selectMyInfo: "My Info",
      pickupServiceExplanationTitle: "Pickup Service",
      pickupServiceExplanationBody:
        "Pickup service refers to transportation from the airport to your home, hotel, or designated destination. This service is provided after your flight arrives and includes coordinated curbside or designated pickup at the airport, subject to real-time traffic conditions within the terminal area.",
      dropoffServiceExplanationTitle: "Drop-Off Service",
      dropoffServiceExplanationBody:
        "Drop-off service refers to transportation from your home, hotel, or designated location to the airport. This service is scheduled in advance to ensure timely arrival at the airport based on your flight departure time and current traffic conditions.",
      phone: "Phone Number",
      passengers: "Passengers",
      luggages: "Luggages",
      carryOns: "Carry-on",
      others: "Other",
      pickupDate: "Pickup Date(PST)",
      pickupTime: "Pickup Time(PST)",
      flightDepartureDate: "Flight Departure Date(PST)",
      flightDepartureTime: "Flight Departure Time(PST)",
      flightArrivalDate: "Flight Arrival Date(PST)",
      flightArrivalTime: "Flight Arrival Time(PST)",
      airlineIncAndNumber: "Flight info",
      dropOffAirport: "Drop off Airport",
      dropOffLocation: "Drop off Location",
      pickupAirport: "Airport",
      pickupLocation: "Pickup Location",
      language: "Language",
      preferredServiceLanguage: "Preferred Service Language",
      english: "English",
      mandarin: "Mandarin",
      contactMethod: "Preferred Contact Method",
      contactMethodTitle: "Contact Method",
      contactDetails: "Contact Details",
      contactDetailsHint: "Please provide the best way for us to contact you.",
      contactDetailsPhonePlaceholder: "Enter phone number",
      contactDetailsWechatPlaceholder: "Enter WeChat ID",
      contactDetailsLinePlaceholder: "Enter LINE ID",
      contactMethodPhoneOption: "Phone Number",
      contactMethodWechatOption: "WeChat ID",
      contactMethodLineOption: "LINE ID",
      contactMethodEmailOption: "Email Address",
      byPhone: "By Phone",
      byWechat: "By WeChat",
      byLine: "By LINE",
      byEmail: "By Email",
      wechatId: "WeChat ID",
      lineId: "LINE ID",
      note: "Note",
      notePlaceholder: "Please enter your special requests here, pets, boosters, carseat, wheelchairs, golf bags, skateboards, surfboards, etc.",
      btnUploadGateCode: "Upload Gate Code",
      msgGateCodeUploaded: "Gate code uploaded",
      fillInDropOffInfo: "Please fill out the airport drop-off information",
      fillInPickupInfo: "Please fill out the airport pick-up information",
      reviewOrder: "Review your order",
      placeOrder: "Place Order",
      submitting: "Submitting...",
      processing: "Processing...",
      processingRequest: "Processing request",
      processingPleaseWait: "Please wait while your request is being processed...",
      previous: "Previous",
      next: "Next",
      priceDetails: "Estimated Price Breakdown",
      confirm: "Confirm",
      myOrders: "My Reservations",
      type: "Type",
      flightNumber: "Flight Number",
      customerName: "Customer Name",
      contactNumber: "Contact Number",
      confirmation: "Confirmation",
      thankYou: "Thank you for your reservation!",
      details: "Details",
      pickupService: "Pickup Service",
      dropoffService: "Dropoff Service",
      status: "Status",
      orderId: "Order ID",
      orderId2: "Order",
      thankOrderTitle: "Thanks for booking with Bluesky Shuttle & Tour!",
      thankOrderBody1: "Your order number is",
      thankOrderBody2: ". We have emailed your order confirmation at {{email}}.",
      airport: "Airport",
      company: "Company",
      addr: "Address",
      // addr1: "Common address 1",
      // addr2: "Common address 2",
      streetAddress: "Street address",
      zipcode: "ZIP Code",
      city: "city",
      selState: "Select State",
      driverLogin: "Driver Login",
      passwordChangeSuccess: "Password change successful",
      passwordChangeFailed: "Password change failed",
      noRestDays: "No Rest Days",
      sunday: "Sunday",
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      labelRestDay: "Rest Day",
      labelOrderList: "Your historical Assignment",
      labelCurOrderList: "Your current Assignment",
      labelAssignedDriverInfo: "Your assigned Driver's info",
      labelNoOrders: "No orders",
      labelNoData: "No data",
      labelNoDayOrders: "No orders for the day",
      noSavedOrders: "No saved orders",
      registerSuccess: "Registration successful, please log in",
      userInfoUpdateSuccess: "User information updated successfully",
      userInfoUpdateFailed: "User information update failed",
      accountDeleteButton: "Delete Account",
      accountDeleteTitle: "Delete Your Account?",
      accountDeleteDescription: "This will permanently delete your Blue Sky Ride account, saved addresses and account preferences, and remove your account access to booking history. Existing bookings will not be canceled or deleted. Order records, including the personal details already stored in them, will be retained.",
      accountDeleteContinue: "Continue",
      accountDeleteVerifyTitle: "Verify Your Identity",
      accountDeletePasswordDescription: "For your security, please enter your current password to confirm that you want to permanently delete your account.",
      accountDeleteGoogleDescription: "For your security, please verify your identity using the Google account associated with this Blue Sky Ride account to confirm permanent deletion.",
      accountDeleteWarning: "This action cannot be undone. Your account profile will be deleted. Existing bookings and order records will be retained.",
      accountDeleteDeleting: "Deleting account…",
      accountDeleteFailed: "Unable to delete your account. Please try again.",
      accountDeleteSuccessTitle: "Your Account Has Been Deleted",
      accountDeleteSuccessDescription: "Your Blue Sky Ride account, saved addresses and account preferences have been permanently deleted. Existing bookings and order records are retained. Account deletion does not cancel any bookings. We’re sorry to see you go.",
      accountDeleteReturnHome: "Return to Homepage",
      accountDeleteRedirect: "You will be redirected to the login page in 5 seconds.",
      accountDeleteClose: "Close",
      accountDeleteShowPassword: "Show password",
      accountDeleteHidePassword: "Hide password",
      errCode11019: "Incorrect password. Please enter your current account password.",
      errCode11020: "Google verification failed. Please select the Google account linked to this account and try again.",
      errCode11021: "This account cannot be deleted. Please contact customer support.",
      baseFare: "Base Fare",
      tips: "Tips",
      flightTime: "Flight Time(PST)",
      flightTimeInDriver: "Flight Time",
      useDate: "Service Date(PST)",
      useTime: "Service Time(PST)",
      useDateTime: "Service Date and Time(PST)",
      useTimeInDriver: "Use Time",
      creditCard: "Credit Card",
      cash: "Cash",
      confirmOrderPromptPart1: "By confirming this order, your reservation will be finalized and assigned to a driver.",
      confirmOrderPromptPart2: "To make any changes after confirmation, please contact our customer support team directly.",
      pleaseConfirmOrderPrompt: "Please review carefully before confirming.",
      pleaseConfirmOrderDetail: "Your order has been reviewed and the final price may reflect updates such as changes in time, route, or passenger count. Once you click <b>Confirm Order</b>, your booking becomes official and cannot be changed. Cancellation policies will apply.",
      confirmOrder: "Confirm Reservation",
      unknown: "Unknown",
      reviewed: "Reviewed",
      unreviewed: "Pending Review",
      unassigned: "Unassigned",
      confirmed: "Confirmed",
      assigned: "Assigned",
      completed: "Completed",
      canceled: "Canceled",
      confirmTitle: "Please confirm",
      accountBilling: "Account Payable",
      titleChangePaymentMethod: "Change payment method",
      titleSelectFromMyAddress: "Please select an address",
      bookingFor: "Booking for",
      bookForMyself: "Myself",
      bookForOthers: "Others",
      labelCheck: "Check",
      labelBaseFarePaymentWay: "Base Fare Payment Method",
      labelTipsPaymentWay: "Tips Payment Method",
      labelComment: "Comment",
      labelAddComment: "Add Comment",
      labelAddress: "Address",
      labelLuggages: "Luggages",
      labelCarryOn: "Carry-on",
      labelMiniVan: "Mini Van",
      labelLuxurySUV: "Luxury SUV",
      descMiniVan: "Toyota Sienna or similar with space for up to 7 passengers.",
      descLuxurySUV:
        "Chevy Suburban, GMC Yukon, or similar with space for up to 6 passengers and 6 medium suitcases.",
      descMiniVehicle: "Toyota Sienna 7 or 8 seater",
      descFeatures: "Complimentary water • Wi-Fi* • Rear Entertainment* • Child seats*",
      labelReservedService: "BlueSky Pick-up Service",
      labelReservedDropoffService: "BlueSky Drop-off Service",
      labelBookingCanceled: "Booking Canceled",
      date: "Date",
      week: "Week",
      service: "Service",
      // airlineCompany: "Airline Company",
      // airlineNumber: "Airline Number",
      flightInfo: "Flight Info",
      phoneNumber: "Phone",
      //"passengers": "Passenger(S)",
      arrivalTime: "Arrival Time",
      address: "Address",
      price: "Price",
      forgotPassword: "Forgot password?",
      resetPassword: "Reset Password",
      resetPasswordDesc:
        "Please input your email address, we will send you a link to reset your password",
      pleaseInputEmail: "Please input email address",
      resetPasswordEmailSent: "Reset password email sent",
      resetPasswordEmailFailed: "Failed to send reset password email",
      sendResetEmail: "Send Reset Email",
      pleaseLoginToViewPrice: "Please login to view price details",
      orderSavedSuccess: "Order saved successfully",
      titleChangePriceMethod: "Change price",
      currentOrders: "Current Orders",
      savedOrders: "Saved Orders",
      savedAt: "Saved at",
      continueOrder: "Continue Order",
      deleteOrder: "Delete Order",
      searchOrder: "Search Order",
      searchFailed: "Search failed",
      search: "Search",
      viewDetails: "Details",
      driverDetailsLink: "View Details:",
      toBeUpdated: "(To be updated)",
      editOrder: "Edit",
      editPickupInfo: "Modify airport pick-up information",
      editDropoffInfo: "Modify airport drop-off information",
      selectPaymentMethod: "Select Payment Method",
      selectPaymentMethodDesc: "Please select a payment method",
      existingOrderWarning: "Existing order",
      existingOrderMessage: "You already have an order for the day, do you want to edit the previous order?",
      orderInfo: "Order Information",
      continueNew: "Continue to create",
      editExisting: "Edit an existing order",
      safetyComplianceNoticeTitle: "Safety & Compliance Notice",
      safetyComplianceNoticeOverloadTitle:
        "Passenger {{passengers}} + {{luggage}} luggages exceed the recommended loading range.",
      safetyComplianceNoticeDesc:
        "To ensure passenger safety and comply with California Vehicle Code regulations regarding vehicle capacity and load limits, we recommend reducing luggage or booking an additional vehicle when passenger and luggage combinations exceed safe operating thresholds.",
      pleaseContactCustomerService: "Please contact customer service for price",
      licensePlate: "License plate number",
      carModel: "Car Model",
      seats: "Seats",
      setNewPassword: "Set New Password",
      confirmReset: "Confirm Reset",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      pleaseInputPassword: "Please input password",
      passwordTooShort: "Password must be at least 6 characters",
      passwordsNotMatch: "Passwords do not match",
      lobbyService: "Lobby service/Help customer checkin",
      lobbyServicePickup: "Lobby Service",
      lobbyServicePickupDetail:
        "Lobby Service Required\n(Additional charge at $20, parking fee not included)",
      lobbyServiceDropoff: "Lobby Service",
      lobbyServiceDropoffDetail:
        "Lobby Service Required\n(Additional charge at $50, parking fee not included)",
      dropoffTimeNotice:
        "International flights: allow 3.5 hours; domestic flights: 2.5 hours",
      lobbyServiceShort: "Lobby Service",
      cancelOrderPrompt: "Are you sure you want to cancel your order?",
      viewMyOrders: "View My Orders",
      menuManageAccount: "Manage your Account",
      menuChangePassword: "Change Password",
      menuHiUser: "Hi, {{name}}",
      resetPasswordSuccess: "Password reset successful. Please log in again.",
      pleaseInputAllPasswords: "Please input all password fields",
      invalidResetToken: "Invalid token, please log in again",
      passwordResetFailed: "Password reset failed",
      labelPaymentMethods: "Payment Methods",
      labelCashPayment: "Cash(Given to the driver after the service)",
      labelCardPayment:
        "Card(Extra 3.6% Service Fee applied, please contact our office for the payment)",
      labelContactInfo: "Contact us",
      labelOfficeChinese: "Chinese",
      labelOfficeEnglish: "English",
      labelBookingWithText: "Booking with Text",
      labelOnlineBooking: "Online Booking",
      //labelServicePolicyTitle:
      //  "Airport Transfer Service Customer Agreement",
      labelMeetGreetPolicy:
        "We provide a complimentary curb-side pickup service. If you require the driver to enter the airport lobby and hold a sign for your arrival, we will charge an additional",
      labelMeetGreetPolicyExtra:
        "service fee and parking fee, parking fees will be based on the actual parking ticket for that day.",
      labelWaitingPolicy:
        "Based on the landing time of your flight on the given day, if the driver waits for more than 3 hours, there will be an additional charge of",
      labelCancellationPolicy:
        "To cancel your order, please notify us as soon as possible. Canceling within 3 hours before the flight will incur a full charge. If your flight is canceled by the airline, please inform us at least 3 hours in advance. Otherwise, it will have a 50% charge of the order.",
      labelFlightNumberPolicy:
        "Please make sure to confirm that the flight number you provide is correct to ensure the driver can accurately wait for your arrival.",
      labelLocationChangePolicy:
        "On the day of the ride, changes to the pickup location are not allowed. If changes are necessary, please contact our company in advance.",
      labelLuggagePolicy:
        "When the vehicle's capacity allows, each passenger may bring 2 pieces of luggage. If additional luggage is required, charges may apply depending on the circumstances. Additional fees may also apply for special items other than luggage.",
      labelTollPolicy:
        "Toll roads are not included in the service, and if passengers request the driver to use toll roads, an additional fee is required.",
      labelPolicyDisclaimer:
        "Please note that these charges and policies may vary depending on the specific airport transfer service provider.",
      labelPolicyConfirmation:
        "Be sure to carefully read and confirm the relevant terms and fees before booking the service.",
      labelVehicle: "Vehicle",
      labelFeatures: "Features",
      labelCommentHolder: "Please enter your comment...",
      labelDriverName: "Driver Name",
      labelDriverPhone: "Driver Phone",
      labelBaseFee: "Base Fair",
      labelPickupFee: "Pickup Service price",
      labelAirportServiceFee: "Airport Service Fee",
      labelParkingFee: "First Hour Parking Fee",
      labelPassengerFee: "Number of extra Passenger cost",
      labelSpecialTimeFee: "Late night or early morning surcharge",
      labelStopsFee: "Multiple Stops charge",
      labelOtherFee: "Other Fee",
      labelTotalFee: "Total Price",
      labelChangeReason: "Please enter the reason for the changes",
      labelCancelReason: "Please enter the cancellation reason",
      labelTotal: "Total",
      labelOperation: "Operation",
      labelPreferredDriver: "Preferred Driver",
      labelDislikedDriver: "Disliked Driver",
      labelPromotion: "Promotion",
      labelOrderDate: "Order Date",
      labelVenmo: "Please kindly put the passenger's name and date in the transaction notes",
      labelPickupOptions: "Pickup Options and Additional Services",
      labelCurbsidePickup: "Complimentary Curbside Pickup",
      labelCurbsidePickupDesc: "We provide a standard curbside pickup service at no additional cost.",
      labelLobbyPickup: "Lobby Pickup with Signage",
      labelLobbyPickupDesc: "If you require the driver to enter the airport lobby and hold a sign for your arrival, a ",
      labelServiceFee: " service fee",
      labelParkingFeesDesc: "along with applicable parking fees, will be charged. Parking fees will be determined based on the actual parking ticket for that day.",
      labelWaitingTimeCharges: "Waiting Time Charges",
      labelWaitingTimeDesc: "Based on the flight’s landing time on the scheduled day, if the driver is required to wait for more than ",
      labelHours: " hours",
      labelAdditionalChargeDesc: " an additional charge of ",
      labelPerHour: " per hour",
      labelWillApply: " will apply.",
      labelCancellationPolicies: "Cancellation and Flight Change Policies",
      labelCancellationsDesc: "Cancellations made within ",
      labelBeforeFlightDesc: " before the scheduled flight departure will be subject to a ",
      labelFullCharge: " full charge ",
      labelOfBooking: " of the booking.",
      labelAirlineCancelsDesc: "If the airline cancels the flight, passengers must notify us at least ",
      labelHoursInAdvance: " hours in advance ",
      labelToAvoidCharges: "to avoid charges. Failure to do so will result in a ",
      labelCharge: " charge ",
      labelOfOrder: " of the order.",
      labelImportantFlightInfo: "Important Flight Information",
      labelPassengersMustEnsure: "Passengers must ensure that the ",
      labelFlightNumberAccurate: "flight number provided is accurate ",
      labelToEnableDriver: "to enable the driver to track the arrival time and wait accordingly.",
      labelPickupLocationLuggage: "Pickup Location and Luggage Policy",
      labelPickupLocationChanges: "Pickup Location Changes",
      labelChangesToPickup: "Changes to the pickup location on the day of service are ",
      labelNotPermitted: "not permitted",
      labelAnyNecessaryAdjustments: "Any necessary adjustments must be coordinated with our company in advance.",
      labelLuggageAllowance: "Luggage Allowance",
      labelEachPassenger: "Each passenger is allowed up to ",
      labelTwoPiecesOfLuggage: "two (2) pieces of luggage",
      labelSubjectToVehicle: "subject to vehicle capacity. Additional baggage may incur extra charges based on the circumstances. Special items beyond standard luggage may also be subject to additional fees.",
      labelTollRoadFees: "Toll Road Fees",
      labelTollRoadFeesAre: "Toll road fees are ",
      labelNotIncluded: "not included ",
      labelInStandardService: "in the standard service charge. If a passenger requests the use of toll roads, additional charges will apply.",
      labelServiceFeesAndPolicies: "Service fees and policies may vary depending on the specific airport transfer provider. We recommend reviewing and confirming all terms and applicable charges before booking your service.",
      labelBlueskyDropOffService: "Bluesky Drop Off Service Customer Agreement",
      labelLobbyAssistance: "Lobby Assistance and Boarding Support",
      labelEntranceToLobby: "Entrance to Lobby Service",
      labelServiceFeeOf: "A service fee of ",
      labelPlusParkingFees: " plus applicable parking fees, will be charged. The driver will assist with luggage transportation to the airport lobby. Parking fees will be determined based on the actual parking ticket for that day.",
      labelBoardingAssistance: "Boarding Assistance",
      labelIfAdditionalAssistance: "If additional assistance is required beyond the lobby, such as escorting the passenger through the check-in and boarding process, the fee is ",
      dropoffPolicyTitle: "Bluesky Drop Off Service Agreement",
      dropoffPolicySectionLobby: "1. Lobby & Boarding Assistance",
      dropoffPolicyLobbyLabel: "Lobby Assistance:",
      dropoffPolicyLobbyText:
        " $20 plus actual parking fees. The driver will assist with luggage from the vehicle to the airport lobby.",
      dropoffPolicyBoardingLabel: "Boarding Assistance:",
      dropoffPolicyBoardingPrefix:
        " Additional assistance beyond the lobby, including check-in and pre-boarding assistance where permitted, is ",
      dropoffPolicyBoardingHighlight: "$50 per hour",
      dropoffPolicyBoardingSuffix: ".",
      dropoffPolicySectionWaiting: "2. Waiting Time",
      dropoffPolicyWaitingGrace:
        "A 20-minute complimentary grace period",
      dropoffPolicyWaitingGraceSuffix:
        " is provided after the driver arrives at the confirmed pickup location.",
      dropoffPolicyWaitingFeePrefix:
        "If waiting exceeds 20 minutes, a minimum ",
      dropoffPolicyWaitingFeeMiddle: " waiting fee applies. The fee will then be calculated at ",
      dropoffPolicyWaitingFeeHighlight:
        "$1 per minute based on the total waiting time",
      dropoffPolicyWaitingFeeSuffix: ".",
      dropoffPolicySectionChanges: "3. Last-Minute Changes",
      dropoffPolicyChangesPrefix:
        "Changes to the pickup time or location requested within ",
      dropoffPolicyChangesTimeHighlight: "3 hours of the scheduled service time",
      dropoffPolicyChangesMiddle: " may incur a ",
      dropoffPolicyChangesFeeHighlight: "$30 emergency dispatch fee",
      dropoffPolicyChangesSuffix: ", plus any fare difference.",
      dropoffPolicyChangesAvailabilityPrefix:
        "All changes are subject to driver and vehicle availability and ",
      dropoffPolicyChangesAvailabilityHighlight: "are not guaranteed",
      dropoffPolicyChangesAvailabilitySuffix: ".",
      dropoffPolicySectionCancellation: "4. Cancellation",
      dropoffPolicyPassengerCancellationLabel: "Passenger Cancellation:",
      dropoffPolicyPassengerCancellationPrefix: " Cancellation within ",
      dropoffPolicyPassengerCancellationTime:
        "3 hours of the scheduled service time",
      dropoffPolicyPassengerCancellationMiddle: " is subject to a ",
      dropoffPolicyPassengerCancellationFee: "full charge",
      dropoffPolicyPassengerCancellationSuffix: ".",
      dropoffPolicyAirlineCancellationLabel: "Airline Cancellation:",
      dropoffPolicyAirlineCancellationPrefix:
        " If a flight is canceled by the airline, please notify us at least ",
      dropoffPolicyAirlineCancellationTime:
        "3 hours before the scheduled service time",
      dropoffPolicyAirlineCancellationMiddle: ". Late notice is subject to a ",
      dropoffPolicyAirlineCancellationFee: "50% charge",
      dropoffPolicyAirlineCancellationSuffix: ".",
      dropoffPolicySectionLuggage: "5. Luggage",
      dropoffPolicyLuggagePrefix: "Each passenger may bring up to ",
      dropoffPolicyLuggageHighlight: "two (2) standard pieces of luggage",
      dropoffPolicyLuggageMiddle: ", subject to vehicle capacity.",
      dropoffPolicyLuggageAdditional:
        "Additional, oversized, or special items may require additional charges or a larger vehicle.",
      dropoffPolicySectionToll: "6. Toll Roads & General Terms",
      dropoffPolicyTollPrefix: "Toll road fees are not included",
      dropoffPolicyTollMiddle:
        " and will be charged when toll roads are requested.",
      dropoffPolicyGeneralTerms:
        "Fees and service arrangements may vary by airport, route, and service provider. Please review and confirm all reservation details and applicable charges before service.",
      labelIfDriverWaits: "If the driver waits for more than ",
      labelMinutes: "minutes ",
      labelAfterArriving: "after arriving at the designated pickup location, an additional ",
      labelWillBeCharged: " will be charged. Waiting time fees will continue to accrue at ",
      labelPer30Minutes: "per additional 30-minute interval",
      labelCancellationsMade: "Cancellations made within ",
      labelBeforeScheduled: " before the scheduled flight departure will be subject to a",
      labelOfTheBooking: "of the booking.",
      labelIfAirlineCancels: "If the airline cancels the flight, passengers must notify us at least ",
      labelOfTheOrder: "of the order.",
      labelNoHistoryOrders: "No order history found",
      labelOrderLoadError: "Failed to load order",
      labelPotentialFee: "Other potential charge",
      labelPotentialFeeNotice: "parking fee may apply",
      labelParkingSuffix: "Parking",
      // button
      btnAddAddress: "Add Address",
      rdoSingleAddr: "Single address",
      rdoMultiAddr: "Multiple addresses",
      btnMiniVan: "Mini Van",
      btnLuxurySUV: "Luxury SUV",
      btnUpdate: "Update",
      btnBack: "Back",
      btnGoBack: "Go back",
      btnLoginAsGuest: "Login as guest",
      btnAddComment: "Add Comment",
      btnQrCode: "Gate Code",
      btnCancel: "Cancel",
      btnSubmit: "Submit",
      btnCancelOrder: "Cancel this Reservation",
      btnConfirm: "Confirm submission",
      btnCurOrder: "My Reservations",
      btnDriverOrder: "My Assignment",
      btnHistory: "Reservation History",
      btnDriverHistory: "Assignment Record",
      btnSetPrefer: "Set to Preferred Driver",
      btnSetDislike: "Set to Dislike Driver",
      btnSaveOrder: "Save Order",
      btnQueryOrder: "Order Inquiry",
      btnFromMyAddress: "Choose from My address book",
      btnLogout: "Logout",
      btnClose: "Close",
      btnOpenInNewTab: "Open In New Tab",
      btnDelete: "Delete",
      btnCommentService: "Comment on Service",
      btnBackToWeb: "Return to Homepage",
      // dialog
      dialogTitleComment: "Service Review",
      dialogDescComment: "Please comment this service",
      // message
      msgComentSuccess: "Comment added successfully",
      msgComentFailed: "Comment added failed",
      msgConfirmStatusChange:
        "Are you sure you want to modify the status of your order? You cannot modify it again after submitting.",
      msgUnpaidFeeWarning: "You still have unpaid fees, please settle them as soon as possible.",
      msgUnpaidFeeBan: "The account has been disabled due to unpaid fees.",
      msgLoadOrdersError: "Failed to load order: ",
      msgConfirmOrderError: "Failed to confirm order: ",
      msgCancelOrderError: "Failed to cancel order: ",
      msgCancelRequestSuccess: "Cancellation request submitted successfully",
      msgCancelAlreadyRequested: "Cancellation request already submitted for this order",
      msgAddrRemoveSuccess: "Address removed successfully",
      // error
      errNameRequired: "Name is required",
      errPhoneRequired: "Phone is required",
      errWechatRequired: "WeChat ID is required",
      errLineRequired: "LINE ID is required",
      errEmailRequired: "Email is required",
      errEmailInvalid: "Email address must be a valid address",
      errPassengersRequired: "Please select the number of passengers",
      errLuggagesRequired: "Please select the number of luggages",
      errCarryOnsRequired: "Please select the number of carry-on",
      errPickupLocationRequired: "Pickup location is required",
      errDropOffLocationRequired: "Drop off location is required",
      errNoPriceInfo: "No price information for the current location",
      errAirportRequired: "Please select an airport",
      errGoogleSigninFailed: "Google Sign-in Failed",
      errTimeLimited: "Time limit exceeded",
      errPhoneInvalid: "Please enter a valid phone number (can include + sign, 10-15 digits)",
      errCityStateRequired: "City and ZIP Code are required",
      errStreetRequired: "Please enter a street address",
      errCityRequired: "Please enter a city",
      // errStateRequired: "State is required",
      errZipCodeRequired: "Please enter a zipcode",
      errGetPriceFailed: "Failed to obtain price information",
      errPlaceOrderFailed: "Failed to place order, please try again later",
      errZipCodeInvalid: "Please enter a valid zipcode",
      errNameTooShort: "Name length is too short",
      errNameTooLong: "The name is too long",
      errMaxLength64: "Must be 64 characters or fewer",
      errPermissionDenied: "Administrator action required",
      errCancelReasonTooShort: "Cancellation reason must be at least 2 characters",
      errUseTimeBeforeNow: "The selected time must be in the future.",
      errQrcodeFileInvalidType: "qrcodeFile must be png/jpg/jpeg/webp image",
      errQrcodeFileTooLarge: "qrcodeFile size must be less than or equal to 5MB",
      errFlightTimeLessThanTwoHours: "The flight time needs to be at least 2 hours longer than the car time",
      errDropoffCompleteTooEarly: "Airport drop-off orders must be marked as completed after {{time}}",
      errPickupCompleteTooEarly: "Pickup orders must be marked complete after {{time}}",
      errCode506: "Your driver account has been frozen, please contact our customer service team.",
      errCode11001: "Incorrect email address or password",
      errCode11014: "Unable to Cancel Reservation: Cancellations are not permitted within 3 hours of the scheduled service time. For further assistance, please contact our customer service team.",
      errGeneric: "An error occurred!",
      errFlightNumberRequired: "Please enter flight number",
      legalLastUpdated: "Last updated",
      legalContactTitle: "Contact Us",
      legalWebsiteLabel: "Website",
      legalPhoneLabel: "Phone",
      privacyPolicyTitle: "Privacy Policy",
      privacyPolicyLastUpdatedValue: "August 5, 2026",
      privacyPolicyIntro1:
        "Bluesky Shuttle & Tour respects your privacy. This Privacy Policy explains what information we collect through our website and booking services, how we use it, and the choices available to you.",
      privacyPolicyIntro2:
        "By using this website or submitting a reservation request, you acknowledge that your information may be processed as described in this policy.",
      privacyPolicySectionCollectionTitle: "Information We Collect",
      privacyPolicySectionCollectionBody:
        "We collect information you provide directly to us and limited technical information required to operate the website and our booking flow.",
      privacyPolicySectionCollectionBullet1:
        "Contact details such as your name, email address, phone number, and preferred contact method.",
      privacyPolicySectionCollectionBullet2:
        "Reservation details such as service type, airport, flight information, pickup or drop-off addresses, passenger count, luggage count, notes, and uploaded gate code images.",
      privacyPolicySectionCollectionBullet3:
        "Basic device or usage information that helps us secure the service, diagnose issues, and improve the booking experience.",
      privacyPolicySectionUsageTitle: "How We Use Information",
      privacyPolicySectionUsageBody:
        "We use the information we collect to provide transportation services and support normal business operations.",
      privacyPolicySectionUsageBullet1:
        "To create, confirm, update, and manage reservations.",
      privacyPolicySectionUsageBullet2:
        "To contact you about your booking, timing changes, service issues, payment matters, or support requests.",
      privacyPolicySectionUsageBullet3:
        "To improve our website, prevent misuse, and comply with legal obligations.",
      privacyPolicySectionSharingTitle: "How We Share Information",
      privacyPolicySectionSharingBody:
        "We may share relevant booking information with assigned drivers, service staff, payment or technology providers, and where required by law. We do not sell your personal information through this website.",
      privacyPolicySectionSecurityTitle: "Data Retention and Security",
      privacyPolicySectionSecurityBody:
        "We keep information for as long as needed to operate the service, maintain business records, resolve disputes, and satisfy legal or tax requirements. We use reasonable administrative and technical measures to protect personal information, but no online service can guarantee absolute security.",
      privacyPolicySectionChoicesTitle: "Your Choices",
      privacyPolicySectionChoicesBody:
        "You may contact us to request updates to your account information or to ask questions about the personal information connected to your bookings. Some information may still be retained when required for legal, operational, or fraud-prevention reasons.",
      privacyPolicySectionUpdatesTitle: "Policy Updates",
      privacyPolicySectionUpdatesBody:
        "We may update this Privacy Policy from time to time. When we do, we will post the updated version on this page and update the last updated date above.",
      privacyPolicyContactBody:
        "If you have questions about this Privacy Policy or how we handle your information, please contact Bluesky Shuttle & Tour using the contact details below.",
      termsOfServiceTitle: "Terms of Service",
      termsOfServiceLastUpdatedValue: "August 5, 2026",
      termsIntro1:
        "These Terms of Service govern your access to and use of the Bluesky Shuttle & Tour website and reservation services.",
      termsIntro2:
        "By placing a reservation, browsing this website, or using our services, you agree to these terms and to any additional service-specific policies shown during booking.",
      termsSectionAcceptanceTitle: "Acceptance and Eligibility",
      termsSectionAcceptanceBody:
        "You must provide accurate information when using this website and may use the service only for lawful personal or business transportation needs. You are responsible for activity carried out through your account or submitted reservation details.",
      termsSectionBookingsTitle: "Reservations and Service Details",
      termsSectionBookingsBody:
        "Reservation requests are subject to review, availability, and operational constraints. A submitted request does not guarantee service until it is accepted or confirmed by Bluesky Shuttle & Tour.",
      termsSectionBookingsBullet1:
        "You are responsible for entering accurate flight, time, address, and contact information.",
      termsSectionBookingsBullet2:
        "Additional stops, waiting time, special assistance, parking, tolls, and oversized luggage may result in additional charges.",
      termsSectionBookingsBullet3:
        "Service timing may be affected by traffic, airport rules, weather, carrier delays, and other conditions outside our direct control.",
      termsSectionPricingTitle: "Pricing and Payment",
      termsSectionPricingBody:
        "Quoted prices may be estimated until the reservation is reviewed. Final charges may reflect route details, wait time, extra services, parking, tolls, or applicable service fees. By confirming a reservation, you agree to pay all valid charges associated with the service.",
      termsSectionChangesTitle: "Changes, Cancellations, and No-Shows",
      termsSectionChangesBody:
        "Changes and cancellation requests are subject to the service rules, timing limits, and any applicable fees shown during booking or communicated by our team. Failure to appear at the agreed pickup point, or failure to provide materially accurate booking information, may result in fees or cancellation of service.",
      termsSectionResponsibilitiesTitle: "Customer Responsibilities",
      termsSectionResponsibilitiesBody:
        "To help us provide safe and timely service, customers must cooperate with operational instructions and provide complete booking details.",
      termsSectionResponsibilitiesBullet1:
        "Ensure passenger count, luggage count, and special service requests are accurate.",
      termsSectionResponsibilitiesBullet2:
        "Maintain a reachable phone number or other contact method on the day of service.",
      termsSectionResponsibilitiesBullet3:
        "Comply with reasonable safety instructions from drivers and staff during service.",
      termsSectionLiabilityTitle: "Limitations of Liability",
      termsSectionLiabilityBody:
        "To the maximum extent permitted by law, Bluesky Shuttle & Tour is not liable for indirect, incidental, special, or consequential damages arising from use of the website or transportation service, including delays or losses caused by traffic, weather, airport operations, airline schedule changes, or information provided inaccurately by the customer.",
      termsSectionUpdatesTitle: "Changes to These Terms",
      termsSectionUpdatesBody:
        "We may revise these Terms of Service from time to time. Continued use of the website or services after updated terms are posted means you accept the revised terms.",
      termsContactBody:
        "If you have questions about these Terms of Service, please contact Bluesky Shuttle & Tour using the contact details below.",
      titleCancelRequest: "Submit Cancellation Request",
    },
  },
  zh: {
    translation: {
      yes: "是",
      no: "否",
      login: "登入",
      loginAsGuest: "遊客登入",
      emailAddress: "電子郵件地址",
      password: "密碼",
      gotoRegister: "沒有帳號？註冊一個新帳號",
      registerUser: "註冊用戶",
      register: "註冊",
      name: "姓名",
      backToLogin: "已有帳號？登入",
      serviceType: "服務類型",
      selectPickup: "接機",
      selectDropoff: "送機",
      selectOrders: "我的全部訂單",
      selectAroundCity: "城市旅遊",
      selectMyInfo: "我的資訊",
      pickupServiceExplanationTitle: "接機服務（Pickup Service）",
      pickupServiceExplanationBody:
        "接機服務是指從機場接送乘客前往住家、飯店或指定目的地的交通服務。此服務於航班抵達後進行，司機將依實際機場交通狀況安排於航廈指定地點接送。",
      dropoffServiceExplanationTitle: "送機服務（Drop-Off Service）",
      dropoffServiceExplanationBody:
        "送機服務是指從住家、飯店或指定地點前往機場的交通服務。此服務會依航班起飛時間事先安排，以確保乘客在考量路況後，能準時抵達機場。",
      phone: "電話號碼",
      passengers: "乘客數",
      luggages: "行李箱",
      carryOns: "登機箱",
      others: "其他",
      pickupDate: "接機日期(PST)",
      // 只有送机使用，ENG？pickupTime
      pickupTime: "送機時間(PST)",
      flightDepartureDate: "航班出發日期(PST)",
      flightDepartureTime: "航班出發時間(PST)",
      flightArrivalDate: "航班抵達日期(PST)",
      flightArrivalTime: "航班抵達時間(PST)",
      airlineIncAndNumber: "航班資訊",
      pickupLocation: "接人地點",
      dropOffLocation: "送達地點",
      dropOffAirport: "送機機場",
      pickupAirport: "接機機場",
      language: "語言",
      preferredServiceLanguage: "偏好服務語言",
      english: "英文",
      mandarin: "中文(國語)",
      contactMethod: "您的首選聯絡方式",
      contactMethodTitle: "聯絡方式",
      contactDetails: "聯絡資訊",
      contactDetailsHint: "請提供最方便聯繫您的方式。",
      contactDetailsPhonePlaceholder: "請輸入電話號碼",
      contactDetailsWechatPlaceholder: "請輸入微信號",
      contactDetailsLinePlaceholder: "請輸入 LINE ID",
      contactMethodPhoneOption: "電話號碼",
      contactMethodWechatOption: "微信號",
      contactMethodLineOption: "LINE ID",
      contactMethodEmailOption: "電子郵件地址",
      byPhone: "電話",
      byWechat: "微信",
      byLine: "LINE",
      byEmail: "電子郵件",
      wechatId: "微信號",
      lineId: "LINE ID",
      note: "備註",
      notePlaceholder: "請在此處輸入您的特別要求，帶寵物，booster，carseat，wheelchair，高爾夫球袋，滑板，衝浪板等等",
      btnUploadGateCode: "Upload Gate Code",
      msgGateCodeUploaded: "門禁碼已上傳",
      fillInDropOffInfo: "填寫送機資訊",
      fillInPickupInfo: "填寫機場接機資訊",
      reviewOrder: "確認訂單",
      placeOrder: "下訂單",
      submitting: "提交中...",
      processing: "處理中...",
      processingRequest: "正在處理您的請求",
      processingPleaseWait: "請稍候，系統正在處理您的請求...",
      previous: "上一步",
      next: "下一步",
      priceDetails: "預估費用詳細資訊",
      confirm: "確認",
      myOrders: "我的預訂",
      type: "類型",
      flightNumber: "航班號",
      customerName: "顧客姓名",
      contactNumber: "聯絡電話",
      confirmation: "確認資訊",
      thankYou: "感謝您的預訂！",
      details: "詳細資訊",
      pickupService: "接機服務",
      dropoffService: "送機服務",
      status: "狀態",
      orderId: "訂單編號",
      orderId2: "訂單編號",
      thankOrderTitle: "感謝您預訂藍天旅行社的機場接送服務！",
      thankOrderBody1: "您的訂單號是",
      thankOrderBody2: "。我們已透過電子郵件將您的訂單確認書寄送至 {{email}}。",
      airport: "機場",
      company: "公司",
      addr: "常用地址",
      streetAddress: "街道地址",
      zipcode: "郵遞區號",
      city: "城市",
      selState: "選擇州",
      driverLogin: "司機登入",
      passwordChangeSuccess: "密碼變更成功",
      passwordChangeFailed: "密碼變更失敗",
      noRestDays: "無休",
      sunday: "周日",
      monday: "周一",
      tuesday: "周二",
      wednesday: "周三",
      thursday: "周四",
      friday: "周五",
      saturday: "周六",
      labelRestDay: "休息日",
      labelOrderList: "歷史任務列表",
      labelCurOrderList: "當前任務列表",
      labelAssignedDriverInfo: "以下是為您提供本次服務的司機資訊",
      labelNoOrders: "沒有訂單",
      labelNoData: "無資料",
      labelNoDayOrders: "沒有當天的訂單",
      noSavedOrders: "沒有儲存的訂單",
      registerSuccess: "註冊成功，請登入",
      userInfoUpdateSuccess: "使用者資訊更新成功",
      userInfoUpdateFailed: "使用者資訊更新失敗",
      accountDeleteButton: "刪除帳戶",
      accountDeleteTitle: "確定要刪除您的帳戶嗎？",
      accountDeleteDescription: "這將永久刪除您的 Blue Sky Ride 帳戶、已儲存的地址與帳戶偏好設定，並移除透過此帳戶查閱預約紀錄的權限。現有預約不會被取消或刪除。訂單紀錄及其中已儲存的個人資料將予以保留。",
      accountDeleteContinue: "繼續",
      accountDeleteVerifyTitle: "驗證您的身分",
      accountDeletePasswordDescription: "為保障您的帳戶安全，請輸入目前的密碼，以確認您要永久刪除帳戶。",
      accountDeleteGoogleDescription: "為保障您的帳戶安全，請使用與此 Blue Sky Ride 帳戶綁定的 Google 帳戶驗證身分，以確認永久刪除帳戶。",
      accountDeleteWarning: "此操作無法復原。您的帳戶資料將被刪除，現有預約與訂單紀錄將予以保留。",
      accountDeleteDeleting: "正在刪除帳戶…",
      accountDeleteFailed: "無法刪除您的帳戶，請稍後再試。",
      accountDeleteSuccessTitle: "您的帳戶已刪除",
      accountDeleteSuccessDescription: "您的 Blue Sky Ride 帳戶、已儲存的地址與帳戶偏好設定已永久刪除。現有預約與訂單紀錄仍會保留，刪除帳戶不會取消任何預約。感謝您曾經使用我們的服務。",
      accountDeleteReturnHome: "返回首頁",
      accountDeleteRedirect: "將於 5 秒後自動返回登入頁面。",
      accountDeleteClose: "關閉",
      accountDeleteShowPassword: "顯示密碼",
      accountDeleteHidePassword: "隱藏密碼",
      errCode11019: "密碼錯誤，請輸入此帳戶目前的密碼。",
      errCode11020: "Google 身分驗證失敗，請選擇與此帳戶綁定的 Google 帳戶後重試。",
      errCode11021: "此帳戶無法刪除，請聯絡客服人員。",
      baseFare: "車資",
      tips: "小費",
      flightTime: "航班時間(PST)",
      flightTimeInDriver: "航班時間",
      useDate: "用車日期(PST)",
      useTime: "用車時間(PST)",
      useDateTime: "用車日期和時間(PST)",
      useTimeInDriver: "用車時間",
      creditCard: "信用卡",
      cash: "現金",
      confirmOrderPromptPart1: "透過確認此訂單，您的預訂將被最終確認並分配給司機。",
      confirmOrderPromptPart2: "確認後若需進行任何更改，請直接聯繫我們的客戶支援團隊。",
      pleaseConfirmOrderPrompt: "請在確認前仔細核對訂單內容。",
      pleaseConfirmOrderDetail: "您的訂單已由我們審核，最終價格可能因時間、路線或乘客人數的變動而調整。點選<b>確認訂單</b>後，預訂將正式生效，無法更改，並將適用取消政策。",
      confirmOrder: "確認預訂",
      unknown: "未知",
      reviewed: "已審核",
      unreviewed: "未審核",
      unassigned: "未指派",
      confirmed: "已確認",
      assigned: "已分配",
      completed: "已完成",
      canceled: "已取消",
      confirmTitle: "請確認",
      accountBilling: "記帳",
      pleaseLoginToViewPrice: "請登入後查看價格詳情",
      orderSavedSuccess: "訂單已儲存",
      titleChangePaymentMethod: "更改付款方式",
      titleChangePriceMethod: "更改收費方式",
      titleSelectFromMyAddress: "請選擇地址",
      bookingFor: "預訂人",
      bookForMyself: "我自己",
      bookForOthers: "其他人",
      labelCheck: "支票",
      labelBaseFarePaymentWay: "車資付款方式",
      labelTipsPaymentWay: "小費付款方式",
      labelComment: "評論",
      labelAddComment: "新增評論",
      labelAddress: "地址",
      labelLuggages: "大行李",
      labelCarryOn: "隨身行李",
      labelMiniVan: "迷你車",
      labelLuxurySUV: "豪華SUV",
      descMiniVan: "Toyota Sienna 或同級車款，可搭載最多 7 位乘客。",
      descLuxurySUV: "Chevy Suburban, GMC Yukon, 或類似的空間可容納6名乘客和6個中等行李。",
      descMiniVehicle: "Toyota Sienna 七人或八人座",
      descFeatures: "免費礦泉水 • Wi-Fi* • 後座娛樂系統* • 兒童安全座椅*",
      labelReservedService: "藍天旅行社接機訂車服務單",
      labelReservedDropoffService: "藍天旅行社送機服務單",
      labelBookingCanceled: "訂單已取消",
      date: "日期",
      week: "星期",
      service: "服務類型",
      flightInfo: "航班資訊",
      phoneNumber: "電話號碼",
      arrivalTime: "抵達時間",
      address: "地址",
      price: "價格",
      forgotPassword: "忘記密碼？",
      resetPassword: "重設密碼",
      resetPasswordDesc: "請輸入您的電子郵件地址，我們將向您發送重設密碼的連結",
      pleaseInputEmail: "請輸入電子郵件地址",
      resetPasswordEmailSent: "重設密碼郵件已發送",
      resetPasswordEmailFailed: "發送重設密碼郵件失敗",
      sendResetEmail: "發送重設郵件",
      currentOrders: "當前訂單列表",
      savedOrders: "已儲存訂單列表",
      savedAt: "儲存於",
      continueOrder: "繼續處理訂單",
      deleteOrder: "刪除訂單",
      searchOrder: "查詢訂單",
      searchFailed: "查詢訂單失敗",
      search: "查詢",
      viewDetails: "查看預約詳情",
      driverDetailsLink: "查看詳情：",
      toBeUpdated: "(待更新)",
      editOrder: "編輯",
      editPickupInfo: "修改接機資訊",
      editDropoffInfo: "修改送機資訊",
      selectPaymentMethod: "選擇付款方式",
      selectPaymentMethodDesc: "請選擇您想要使用的付款方式",
      existingOrderWarning: "已有訂單",
      existingOrderMessage: "你在當天已經有一個訂單，你要編輯上一個訂單嗎？",
      orderInfo: "訂單資訊",
      continueNew: "繼續新增",
      editExisting: "編輯現有訂單",
      safetyComplianceNoticeTitle: "安全與法規提示",
      safetyComplianceNoticeOverloadTitle:
        "乘客數 {{passengers}} 人 + 行李箱數 {{luggage}} 個，已超出建議載運範圍。",
      safetyComplianceNoticeDesc:
        "為確保行車安全並符合加州交通法規（California Vehicle Code）關於乘客與載物容量的要求，當乘客與行李組合超過車輛安全裝載標準時，建議您減少行李數量並預訂第二台車。",
      pleaseContactCustomerService: "請聯絡客服詢問價格",
      licensePlate: "車牌號碼",
      carModel: "車型",
      seats: "座位數",
      setNewPassword: "設定新密碼",
      confirmReset: "確認重設",
      currentPassword: "目前密碼",
      newPassword: "新密碼",
      confirmPassword: "確認密碼",
      pleaseInputPassword: "請輸入密碼",
      passwordTooShort: "密碼長度至少為6位",
      passwordsNotMatch: "兩次密碼輸入不一致",
      lobbyService: "進去舉牌接機／協助乘客登機",
      lobbyServicePickup: "進入機場大廳接機服務",
      lobbyServicePickupDetail:
        "進入機場大廳接機服務（加收舉牌接機費用 $20，不包含機場停車費）",
      lobbyServiceDropoff: "進入機場大廳送機服務",
      lobbyServiceDropoffDetail:
        "進入機場大廳送機服務（加收送機登記服務費 $50，不包含機場停車費）",
      dropoffTimeNotice: "國際航班請預留 3.5 小時，國內航班建議預留 2.5 小時",
      lobbyServiceShort: "大堂服務",
      cancelOrderPrompt: "您確定要取消您的訂單嗎？",
      viewMyOrders: "查看我的訂單",
      menuManageAccount: "管理您的帳戶",
      menuChangePassword: "修改密碼",
      menuHiUser: "歡迎{{name}}",
      resetPasswordSuccess: "重設密碼成功，請重新登入。",
      pleaseInputAllPasswords: "請輸入所有密碼欄位",
      invalidResetToken: "憑證無效，請重新登入",
      passwordResetFailed: "重設密碼失敗",
      labelPaymentMethods: "付款方式",
      labelCashPayment: "現金付款（服務完成後支付給司機）",
      labelCardPayment: "信用卡付款（額外3.6%手續費適用，請聯絡辦公室付款）",
      labelContactInfo: "辦公室聯絡電話",
      labelOfficeChinese: "中文",
      labelOfficeEnglish: "英文",
      labelOnlineBooking: "線上預訂",
      labelBookingWithText: "簡訊預訂",
      labelServicePolicyTitle: "機場接送服務收費標準及政策說明",
      labelVehicle: "車輛",
      labelFeatures: "功能",
      labelCommentHolder: "請輸入評價內容...",
      labelDriverName: "司機姓名",
      labelDriverPhone: "司機電話",
      labelBaseFee: "基本費用",
      labelPickupFee: "接人費用",
      labelAirportServiceFee: "機場服務費",
      labelParkingFee: "第一小時停車費",
      labelPassengerFee: "乘客費用",
      labelSpecialTimeFee: "深夜或清晨服務費",
      labelStopsFee: "多個停靠點費用",
      labelOtherFee: "其他費用",
      labelTotalFee: "總費用",
      labelChangeReason: "請輸入修改原因",
      labelCancelReason: "請輸入取消原因",
      labelTotal: "總計",
      labelOperation: "操作",
      labelPreferredDriver: "偏好司機",
      labelDislikedDriver: "不喜歡的司機",
      labelPromotion: "優惠",
      labelOrderDate: "下訂日期",
      labelVenmo: "請在交易備註中填寫乘客姓名與日期",
      labelPickupOptions: "接機選項與附加服務",
      labelCurbsidePickup: "免費路邊接機",
      labelCurbsidePickupDesc: "我們提供標準路邊接機服務，無需額外費用。",
      labelLobbyPickup: "大廳接機服務",
      labelLobbyPickupDesc: "若您需要司機進入機場大廳並舉牌等候您的到達，將收取",
      labelServiceFee: "服務費",
      labelParkingFeesDesc: "以及適用的停車費。停車費將根據當天的實際停車票據為準。",
      labelWaitingTimeCharges: "等候時間費用",
      labelWaitingTimeDesc: "根據預定日期航班的降落時間，若司機需等候超過",
      labelHours: "小時",
      labelAdditionalChargeDesc: "將收取額外費用",
      labelPerHour: "每小時",
      labelWillApply: "將適用。",
      labelCancellationPolicies: "取消與航班異動政策",
      labelCancellationsDesc: "在預定航班起飛前",
      labelBeforeFlightDesc: "取消預訂將收取",
      labelFullCharge: "全額費用",
      labelOfBooking: "的預訂費用。",
      labelAirlineCancelsDesc: "若航空公司取消航班，乘客需至少提前",
      labelHoursInAdvance: "小時通知我們",
      labelToAvoidCharges: "以免產生費用。若未能如期通知，將收取",
      labelCharge: "費用",
      labelOfOrder: "的訂單費用。",
      labelImportantFlightInfo: "重要航班資訊",
      labelPassengersMustEnsure: "乘客必須確保",
      labelFlightNumberAccurate: "所提供之航班號碼正確無誤",
      labelToEnableDriver: "以利司機追蹤抵達時間並適時等候。",
      labelPickupLocationLuggage: "接機地點與行李政策",
      labelPickupLocationChanges: "接機地點變更",
      labelChangesToPickup: "服務當日變更接機地點",
      labelNotPermitted: "不被允許",
      labelAnyNecessaryAdjustments: "如需變更，請提前與我們聯絡以做適當安排。",
      labelLuggageAllowance: "行李額度",
      labelEachPassenger: "每位乘客最多可攜帶",
      labelTwoPiecesOfLuggage: "兩（2）件行李",
      labelSubjectToVehicle: "依車輛容量而定。如有額外行李，可能需收取額外費用；特殊行李亦可能加收額外費用。",
      labelTollRoadFees: "收費公路費用",
      labelTollRoadFeesAre: "收費公路費用",
      labelNotIncluded: "不包含",
      labelInStandardService: "於標準服務費中。如乘客要求使用收費公路，將加收費用。",
      labelServiceFeesAndPolicies: "服務費用與政策可能依各接送服務供應商而異。建議於預訂前審閱並確認所有條款與適用費用。",
      labelBlueskyDropOffService: "藍天送機服務客戶協議",
      labelLobbyAssistance: "大廳協助與登機支援",
      labelEntranceToLobby: "進入機場大廳服務",
      labelServiceFeeOf: "服務費",
      labelPlusParkingFees: "，另加適用的停車費。司機將協助搬運行李至機場大廳。停車費將依當天實際停車票據為準。",
      labelBoardingAssistance: "登機協助",
      labelIfAdditionalAssistance: "如需大廳外的額外協助，例如陪同乘客辦理報到與登機手續，費用為",
      dropoffPolicyTitle: "藍天旅行社送機服務條款",
      dropoffPolicySectionLobby: "1. 大廳及登機協助",
      dropoffPolicyLobbyLabel: "送入大廳：",
      dropoffPolicyLobbyText:
        " 收取 $20 美元服務費及實際停車費。司機將協助把行李由車輛送至機場大廳。",
      dropoffPolicyBoardingLabel: "登機協助：",
      dropoffPolicyBoardingPrefix:
        " 如需大廳以外之額外協助，包括在允許範圍內協助辦理報到及登機前相關程序，收費為",
      dropoffPolicyBoardingHighlight: "每小時 $50 美元",
      dropoffPolicyBoardingSuffix: "。",
      dropoffPolicySectionWaiting: "2. 等候時間",
      dropoffPolicyWaitingGrace: "司機抵達確認之接送地點後，提供 20分鐘免費寬限等候時間",
      dropoffPolicyWaitingGraceSuffix: "。",
      dropoffPolicyWaitingFeePrefix: "如等候超過20分鐘，最低收取 ",
      dropoffPolicyWaitingFeeMiddle: " 美元等候費，之後按照總等候時間",
      dropoffPolicyWaitingFeeHighlight: "每分鐘 $1 美元",
      dropoffPolicyWaitingFeeSuffix: "計算。",
      dropoffPolicySectionChanges: "3. 臨時更改",
      dropoffPolicyChangesPrefix: "如於預定服務時間前",
      dropoffPolicyChangesTimeHighlight: "3小時內",
      dropoffPolicyChangesMiddle: "要求更改接送時間或地點，可能收取 ",
      dropoffPolicyChangesFeeHighlight: "$30美元緊急調度費",
      dropoffPolicyChangesSuffix: " 及相關車資差額。",
      dropoffPolicyChangesAvailabilityPrefix:
        "所有更改均視司機及車輛調度情況而定，",
      dropoffPolicyChangesAvailabilityHighlight: "無法保證接受更改",
      dropoffPolicyChangesAvailabilitySuffix: "。",
      dropoffPolicySectionCancellation: "4. 取消政策",
      dropoffPolicyPassengerCancellationLabel: "乘客取消：",
      dropoffPolicyPassengerCancellationPrefix: " 如於預定服務時間前",
      dropoffPolicyPassengerCancellationTime: "3小時內",
      dropoffPolicyPassengerCancellationMiddle: "取消，將收取",
      dropoffPolicyPassengerCancellationFee: "全額費用",
      dropoffPolicyPassengerCancellationSuffix: "。",
      dropoffPolicyAirlineCancellationLabel: "航空公司取消航班：",
      dropoffPolicyAirlineCancellationPrefix:
        " 如航班由航空公司取消，請至少於預定服務時間",
      dropoffPolicyAirlineCancellationTime: "3小時前",
      dropoffPolicyAirlineCancellationMiddle: "通知我們；逾時通知將收取訂單金額之 ",
      dropoffPolicyAirlineCancellationFee: "50%",
      dropoffPolicyAirlineCancellationSuffix: "。",
      dropoffPolicySectionLuggage: "5. 行李規定",
      dropoffPolicyLuggagePrefix: "每位乘客最多可攜帶",
      dropoffPolicyLuggageHighlight: "兩（2）件標準行李",
      dropoffPolicyLuggageMiddle: "，並以車輛實際容量為限。",
      dropoffPolicyLuggageAdditional:
        "額外、超大型或特殊行李可能產生額外費用或需要安排較大型車輛。",
      dropoffPolicySectionToll: "6. 收費道路及一般條款",
      dropoffPolicyTollPrefix: "一般車資不包含收費道路費用",
      dropoffPolicyTollMiddle: "；如乘客要求使用收費道路，相關費用將另行收取。",
      dropoffPolicyGeneralTerms:
        "實際收費及服務安排可能因機場、路線及服務提供商而有所不同。請於服務前確認訂單內容及所有適用費用。",
      labelIfDriverWaits: "若司機於抵達指定接人地點後等待超過",
      labelMinutes: "分鐘",
      labelAfterArriving: "，將額外收取",
      labelWillBeCharged: "的費用。等候時間費用將以",
      labelPer30Minutes: "每額外30分鐘繼續累計。",
      labelCancellationsMade: "在預定航班起飛前",
      labelBeforeScheduled: "取消預訂將收取",
      labelOfTheBooking: "的預訂費用。",
      labelIfAirlineCancels: "若航空公司取消航班，乘客需至少提前",
      labelOfTheOrder: "的訂單費用。",
      labelNoHistoryOrders: "沒有歷史訂單",
      labelOrderLoadError: "載入訂單失敗",
      labelPotentialFee: "潛在費用",
      labelPotentialFeeNotice: "將收取機場停車費",
      labelParkingSuffix: "停車費",
      // button
      btnAddAddress: "新增地址",
      rdoSingleAddr: "單一地址",
      rdoMultiAddr: "多個地址",
      btnMiniVan: "Mini Van",
      btnLuxurySUV: "豪華SUV",
      btnUpdate: "更新",
      btnBack: "返回",
      btnGoBack: "返回",
      btnLoginAsGuest: "遊客登入",
      btnAddComment: "新增評論",
      btnQrCode: "門禁二維碼",
      btnCancel: "取消",
      btnSubmit: "提交",
      btnCancelOrder: "取消本次預約服務",
      btnConfirm: "確認提交",
      btnCurOrder: "我的訂單",
      btnDriverOrder: "我的工作單",
      btnHistory: "歷史訂單",
      btnDriverHistory: "歷史工作單",
      btnSetPrefer: "設為偏好司機",
      btnSetDislike: "設為不喜歡的司機",
      btnSaveOrder: "儲存訂單",
      btnQueryOrder: "查詢訂單",
      btnFromMyAddress: "從我的地址簿選擇",
      btnLogout: "登出",
      btnClose: "關閉",
      btnOpenInNewTab: "新分頁開啟",
      btnDelete: "刪除",
      btnCommentService: "評論服務",
      btnBackToWeb: "返回官網",
      // dialog
      dialogTitleComment: "評論服務",
      dialogDescComment: "請對本次服務進行評價",
      // message
      msgComentSuccess: "評論新增成功",
      msgComentFailed: "評論新增失敗",
      msgConfirmStatusChange: "您確認要修改訂單狀態嗎？提交後將無法再次變更。",
      msgUnpaidFeeWarning: "您尚有未結清費用，請盡快付款",
      msgUnpaidFeeBan: "因未結清費用，帳號已被停用",
      msgLoadOrdersError: "載入訂單失敗：",
      msgConfirmOrderError: "確認訂單失敗：",
      msgCancelOrderError: "取消訂單失敗：",
      msgCancelRequestSuccess: "取消申請已成功送出",
      msgCancelAlreadyRequested: "此訂單已送出取消申請，無法再次申請",
      msgAddrRemoveSuccess: "地址已成功刪除",
      // error
      errNameRequired: "請輸入乘車人姓名",
      errPhoneRequired: "請輸入聯絡電話",
      errWechatRequired: "請輸入微信號",
      errLineRequired: "請輸入 LINE ID",
      errEmailRequired: "請輸入電子郵件地址",
      errEmailInvalid: "電子郵件格式錯誤",
      errPassengersRequired: "請選擇乘客人數",
      errLuggagesRequired: "請選擇行李數量",
      errCarryOnsRequired: "請選擇登機箱數量",
      errPickupLocationRequired: "請輸入接送地點",
      errDropOffLocationRequired: "請輸入送達地點",
      errNoPriceInfo: "目前位置沒有價格資訊",
      errAirportRequired: "請選擇機場",
      errGoogleSigninFailed: "Google 登入失敗",
      errTimeLimited: "時間超出限制",
      errPhoneInvalid: "請輸入有效電話號碼（可包含 + 號，10–15 位數）",
      errCityStateRequired: "城市與郵遞區號為必填欄位",
      errStreetRequired: "請輸入街道地址",
      errCityRequired: "請輸入城市名稱",
      errZipCodeRequired: "請輸入郵遞區號",
      errGetPriceFailed: "取得價格資訊失敗",
      errPlaceOrderFailed: "下單失敗，請稍後再試",
      errZipCodeInvalid: "請輸入有效的郵遞區號",
      errNameTooShort: "姓名過短",
      errNameTooLong: "姓名過長",
      errMaxLength64: "長度不可超過 64 個字元",
      errPermissionDenied: "請聯絡管理員以執行此操作",
      errCancelReasonTooShort: "取消原因至少需要 2 個字",
      errUseTimeBeforeNow: "所選時間必須為未來時間，我們無法提供過去時間之服務",
      errQrcodeFileInvalidType: "qrcodeFile 必須是 png/jpg/jpeg/webp 圖片",
      errQrcodeFileTooLarge: "qrcodeFile 大小不可超過 5MB",
      errFlightTimeLessThanTwoHours: "您的用車時間至少應安排在航班出發前兩小時",
      errDropoffCompleteTooEarly: "送機訂單須於 {{time}} 之後才能標示為完成",
      errPickupCompleteTooEarly: "接機訂單須於 {{time}} 之後才能標示為完成",
      errCode506: "您的司机账户已经被冻结，请联系蓝天旅行社客服",
      errCode11001: "電子郵件地址或密碼錯誤",
      errCode11014: "無法取消預訂：距離預定用車時間少於 3 小時時，無法取消。如需臨時取消服務，請聯絡客服人員。",
      errGeneric: "發生錯誤！",
      errFlightNumberRequired: "請輸入航班號碼",
      legalLastUpdated: "最後更新",
      legalContactTitle: "聯絡我們",
      legalWebsiteLabel: "網站",
      legalPhoneLabel: "電話",
      privacyPolicyTitle: "隱私權政策",
      privacyPolicyLastUpdatedValue: "2026 年 8 月 5 日",
      privacyPolicyIntro1:
        "Bluesky Shuttle & Tour 尊重您的隱私。本隱私權政策說明我們透過網站與預約服務收集哪些資訊、如何使用這些資訊，以及您可以行使的選擇。",
      privacyPolicyIntro2:
        "當您使用本網站或提交預約需求時，即表示您理解並同意我們依本政策所述方式處理您的資訊。",
      privacyPolicySectionCollectionTitle: "我們收集的資訊",
      privacyPolicySectionCollectionBody:
        "我們會收集您主動提供的資料，以及為了營運網站與完成預約流程所需的有限技術資訊。",
      privacyPolicySectionCollectionBullet1:
        "聯絡資料，例如姓名、電子郵件地址、電話號碼與偏好的聯絡方式。",
      privacyPolicySectionCollectionBullet2:
        "預約資料，例如服務類型、機場、航班資訊、接送地址、乘客與行李數量、備註，以及您上傳的門禁碼圖片。",
      privacyPolicySectionCollectionBullet3:
        "協助我們維護安全、排查問題並改善預約體驗的基本裝置或使用資訊。",
      privacyPolicySectionUsageTitle: "我們如何使用資訊",
      privacyPolicySectionUsageBody:
        "我們收集的資訊主要用於提供接送服務，並支援正常的業務營運。",
      privacyPolicySectionUsageBullet1:
        "建立、確認、更新與管理您的預約。",
      privacyPolicySectionUsageBullet2:
        "就您的預約、時間異動、服務問題、付款事項或客服需求與您聯繫。",
      privacyPolicySectionUsageBullet3:
        "改善網站體驗、防止濫用，並遵循法律義務。",
      privacyPolicySectionSharingTitle: "我們如何分享資訊",
      privacyPolicySectionSharingBody:
        "我們可能會將與服務相關的必要預約資訊提供給指派司機、服務人員、付款或技術供應商，以及法律要求下的主管機關。我們不會透過本網站出售您的個人資訊。",
      privacyPolicySectionSecurityTitle: "資料保存與安全",
      privacyPolicySectionSecurityBody:
        "我們會在提供服務、保存營運紀錄、處理爭議，以及滿足法律或稅務義務所需的期間內保留資料。我們會採取合理的管理與技術措施保護個人資訊，但任何線上服務都無法保證絕對安全。",
      privacyPolicySectionChoicesTitle: "您的選擇",
      privacyPolicySectionChoicesBody:
        "您可以聯繫我們，要求更新帳戶資訊，或詢問與預約相關的個人資料處理情況。若因法律、營運或防止詐欺需要，我們仍可能保留部分資料。",
      privacyPolicySectionUpdatesTitle: "政策更新",
      privacyPolicySectionUpdatesBody:
        "我們可能不時更新本隱私權政策。若有更新，我們會在本頁公布最新版本，並同步更新上方的最後更新日期。",
      privacyPolicyContactBody:
        "若您對本隱私權政策或我們處理資訊的方式有疑問，請透過以下聯絡方式與 Bluesky Shuttle & Tour 聯繫。",
      termsOfServiceTitle: "服務條款",
      termsOfServiceLastUpdatedValue: "2026 年 8 月 5 日",
      termsIntro1:
        "本服務條款適用於您對 Bluesky Shuttle & Tour 網站與預約服務的存取及使用。",
      termsIntro2:
        "當您提交預約、瀏覽本網站或使用我們的服務時，即表示您同意遵守本條款，以及預約流程中顯示的其他特定服務政策。",
      termsSectionAcceptanceTitle: "條款接受與使用資格",
      termsSectionAcceptanceBody:
        "您在使用本網站時必須提供正確資訊，且僅得將本服務用於合法的個人或商務接送需求。透過您的帳戶或預約資料所進行的行為，均由您負責。",
      termsSectionBookingsTitle: "預約與服務內容",
      termsSectionBookingsBody:
        "所有預約需求均需視審核結果、可用性與實際營運條件而定。提交預約需求並不代表服務已保證成立，必須經 Bluesky Shuttle & Tour 接受或確認後方為有效。",
      termsSectionBookingsBullet1:
        "您有責任填寫正確的航班、時間、地址與聯絡資訊。",
      termsSectionBookingsBullet2:
        "額外停靠點、等候時間、特殊協助、停車費、過路費與超大行李，可能產生額外費用。",
      termsSectionBookingsBullet3:
        "實際服務時間可能受到交通、機場規定、天氣、航空公司延誤或其他非我們可直接控制因素影響。",
      termsSectionPricingTitle: "價格與付款",
      termsSectionPricingBody:
        "報價在訂單審核完成前可能屬於預估價格。最終費用可能因路線細節、等待時間、附加服務、停車、過路費或其他服務費而調整。當您確認預約時，即表示您同意支付與該服務相關的有效費用。",
      termsSectionChangesTitle: "變更、取消與未到場",
      termsSectionChangesBody:
        "訂單變更與取消需求，將依預約時顯示或由客服通知的服務規則、時間限制及適用費用處理。若未在約定地點出現，或未提供實質正確的預約資訊，可能導致收費或取消服務。",
      termsSectionResponsibilitiesTitle: "客戶責任",
      termsSectionResponsibilitiesBody:
        "為了確保安全且準時的服務，客戶需配合營運安排並提供完整的預約資訊。",
      termsSectionResponsibilitiesBullet1:
        "確認乘客人數、行李數量與特殊服務需求填寫正確。",
      termsSectionResponsibilitiesBullet2:
        "在服務當日保持可聯繫的電話或其他聯絡方式。",
      termsSectionResponsibilitiesBullet3:
        "在服務進行期間遵守司機與工作人員的合理安全指示。",
      termsSectionLiabilityTitle: "責任限制",
      termsSectionLiabilityBody:
        "在法律允許的最大範圍內，對於因使用本網站或接送服務所產生的任何間接、附帶、特殊或衍生性損害，Bluesky Shuttle & Tour 不負責任，包括因交通、天氣、機場營運、航空公司時刻變動或客戶提供資訊不正確所造成的延誤或損失。",
      termsSectionUpdatesTitle: "條款更新",
      termsSectionUpdatesBody:
        "我們可能不時修訂本服務條款。若更新後您仍持續使用本網站或服務，即表示您接受修訂後的條款。",
      termsContactBody:
        "若您對本服務條款有任何疑問，請透過以下聯絡方式與 Bluesky Shuttle & Tour 聯繫。",
      titleCancelRequest: "提交取消申請"
    },
  },
};

const savedLanguage = localStorage.getItem("userLanguage");

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage || "en",
  interpolation: { escapeValue: false },
});

export default i18n;
